module.exports = __webpack_public_path__ + "img/pen-indigo.9e296053.svg";